import { render, staticRenderFns } from "./ProductVariations.vue?vue&type=template&id=08cc9246&scoped=true"
import script from "./ProductVariations.vue?vue&type=script&lang=ts"
export * from "./ProductVariations.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ProductVariations.vue?vue&type=style&index=0&id=08cc9246&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "08cc9246",
  null
  ,true
)

export default component.exports